<template>
  <div
    v-if="docUrl"
    class="documentModal"
  >
    <div
      class="modal"
      :class="mime !== 'application/pdf' ? 'documentModalFull' : ''"
    >
      <div class="close">
        <v-btn
          @click="closeDocumentModal()"
          class="mx-2"
          fab
          dark
          medium
          color="error"
        >
          <v-icon dark> mdi-close </v-icon>
        </v-btn>
      </div>

      <a
        v-if="mime !== 'text/markdown'"
        v-bind:href="authUrl"
        target="_blank"
      >
        <object
          v-if="mime === 'application/pdf'"
          :data="authUrl"
          :type="mime"
          width="100%"
          height="100%"
        ></object>
        <v-img
          width="100%"
          height="100%"
          contain
          v-else
          :src="authUrl"
        ></v-img>

        <!-- <img v-if="mime === 'image'" :src="authUrl" />
        <iframe v-if="subMime === 'pdf'" :src="authUrl" width="100%" height="100%" />-->
      </a>

      <div
        v-else
        class="markdownContainer"
      >
        <div
          class="markdownBody"
          v-html="markdownHtml"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownIt from "markdown-it";

const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
});

export default {
  name: "document-viewer",
  data() {
    return {
      docUrl: false,
      mime: "",
      local: false,
      authUrl: "",
      markdownHtml: "",
    };
  },

  computed: {
    majorMime() {
      if (this.mime.split("/").length === 2) return this.mime.split("/")[0];
      else return "";
    },
    minorMime() {
      if (this.mime.split("/").length === 2) return this.mime.split("/")[1];
      else return "";
    },
    verifydocumentViewer() {
      return this.$documentViewer.documentViewerRsp.docUrl;
    },
  },
  watch: {
    verifydocumentViewer: function (docUrl) {
      this.docUrl = docUrl;
      //this.$documentViewer.documentViewerRsp.docUrl = false;
    },
    docUrl: function (docUrl) {
      if (docUrl) {
        let _ = this;
        let url = docUrl;
        _.markdownHtml = "";

        // Check if local
        if (url.startsWith("data:")) {
          _.mime = url.split(";")[0].split(":")[1];
          _.authUrl = url;
          if (_.mime === "text/markdown") {
            _.renderMarkdownFromDataUrl(url);
          }
        } else if (url.startsWith("/") && url.includes("/pdf/")) {
          {
            _.mime = "application/pdf";
            _.authUrl = _.authorizeLink(_.externalizeLink(docUrl));
          }
        } else if (url.startsWith("/")) {
          this.axios({
            method: "GET",
            url: url,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("authToken"),
              local: window.selectedLanguage,
              OnlyMimeInfo: true,
            },
          }).then(function (response) {
            if (response.data.msg.severity === 0) {
              _.mime = response.data.data.mime;
              if (_.mime === "text/markdown") {
                _.fetchMarkdown(docUrl);
              } else {
                _.authUrl = _.authorizeLink(docUrl);
              }
            } else {
              _.$documentViewer.documentViewerRsp.docUrl = false;
            }
          });
        } else {
          _.mime = "application/pdf";
          _.authUrl = url;
        }
      }
    },
  },
  created() {
    this.docUrl = false;
  },
  methods: {
    renderMarkdownFromDataUrl(url) {
      try {
        const encoded = url.split(",")[1] || "";
        const markdown = window.atob(encoded);
        this.markdownHtml = md.render(markdown);
      } catch (e) {
        this.markdownHtml = "<p>Unable to render markdown.</p>";
      }
    },
    fetchMarkdown(docUrl) {
      let _ = this;
      this.axios({
        method: "GET",
        url: docUrl,
        responseType: "text",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("authToken"),
          local: window.selectedLanguage,
        },
      })
        .then(function (response) {
          const markdown = typeof response.data === "string" ? response.data : "";
          _.markdownHtml = md.render(markdown);
        })
        .catch(function () {
          _.markdownHtml = "<p>Unable to load markdown.</p>";
        });
    },
    closeDocumentModal() {
      this.authUrl = false;
      this.markdownHtml = "";
      this.$documentViewer.documentViewerRsp.docUrl = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.documentModal {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 500;
  padding: 25%;
  overflow: hidden;
  text-align: center;
  .modal {
    background-color: white;
    right: 50px;
    bottom: 50px;
    position: fixed;
    top: 50px;
    left: 50px;
    border-radius: 5px;
    img {
      border-radius: 5px;
      image-orientation: from-image;
      max-width: 100%;
      max-height: 100%;
    }
    iframe {
      height: 100%;
      width: 100%;
    }
  }
}

.documentModal .close {
  position: absolute;
  right: -35px;
  top: -30px;
  z-index: 501;
}

.documentModal::before {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);

  content: " ";
}

.markdownContainer {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;
  text-align: left;
}

.markdownBody {
  max-width: 980px;
  margin: 0 auto;
  color: #1f2937;
  line-height: 1.55;
  font-size: 15px;
}

.markdownBody :deep(h1),
.markdownBody :deep(h2),
.markdownBody :deep(h3) {
  margin-top: 1rem;
  margin-bottom: 0.6rem;
  color: #0f172a;
}

.markdownBody :deep(code) {
  background: #f1f5f9;
  padding: 1px 4px;
  border-radius: 4px;
}

.markdownBody :deep(pre) {
  background: #0f172a;
  color: #e5e7eb;
  padding: 12px;
  border-radius: 8px;
  overflow: auto;
}

.markdownBody :deep(ul),
.markdownBody :deep(ol) {
  padding-left: 1.2rem;
}
</style>
